import React from 'react';
import {
  HeaderSection,
  SubHeaderSection,
  MainSection,
  QuizHeader,
  QuizTimerContainer,
} from '@skooldio/skooldio-classroom-components';
import { useTheme } from 'styled-components';

import { ProgressBar } from 'Components/Base';
import { secondsToTime } from 'Util/datetime';
import { useConfig } from 'Context/ConfigContext';
import { useQuizContext } from 'Context/QuizContext';
import { QUIZ_VARIANTS } from 'Components/Quiz/constant';
import QuizWrapper from 'Components/Quiz/Components/QuizWrapper';

import { useAssessmentContext, SESSION_STATUS } from '../../../../../Context/AssessmentContext';
import QuizBox from '../../../Components/QuizBox';

const Session = ({ history }) => {
  const {
    classroom: { quiz = {} },
  } = useConfig();
  const { bgColor = 'primary' } = quiz;
  const {
    currentQuestionIndex,
    currentQuestion,
    metaData,
    status,
    timeRemaining: secondsRemaining,
  } = useAssessmentContext();
  const {
    variant,
    metadata: { title },
  } = useQuizContext();
  const { colors } = useTheme();
  const timeRemaining = secondsToTime(secondsRemaining);
  const { totalQuestions } = metaData || {};
  const questionNo = currentQuestionIndex + 1;
  const isIncludeSubHeader = timeRemaining && variant !== QUIZ_VARIANTS.GRADED_EXAM;
  const isTimeout = status === SESSION_STATUS.TIMEOUT || status === SESSION_STATUS.READY_TO_GRADE;

  return currentQuestion === null || currentQuestion === undefined ? null : (
    <QuizWrapper subHeader={isIncludeSubHeader}>
      <HeaderSection>
        <QuizHeader
          withProgressBar
          variant={variant}
          onClose={() => history.push('/')}
          title={
            variant === QUIZ_VARIANTS.GRADED_EXAM ? title : `${questionNo} of ${totalQuestions}`
          }
          outerWrapperProps={{ bg: colors[bgColor] }}
        />
        <ProgressBar
          value={(questionNo * 100) / totalQuestions}
          withLabel={false}
          withRadius={false}
          progressColor={'warning'}
          height={'6px'}
          style={{ width: '100%', position: 'absolute', bottom: '0', left: '0', right: '0' }}
        />
      </HeaderSection>
      {variant !== QUIZ_VARIANTS.GRADED_EXAM && timeRemaining && (
        <SubHeaderSection>
          <QuizTimerContainer
            color={isTimeout ? colors.danger : colors.primary}
            isTimeout={isTimeout}
            timeRemaining={timeRemaining}
          />
        </SubHeaderSection>
      )}
      <MainSection>
        <QuizBox />
      </MainSection>
    </QuizWrapper>
  );
};

export default Session;
